
import React from "react";
import ConversationList from "./conversation-list";
import ConversationDeleteDialog from "./conversation-delete-dialog";
import { useConversations } from "./hooks/use-conversations";
import { useConversationDelete } from "./hooks/use-conversation-delete";
import { useIsMobile } from "@/hooks/use-mobile";

export type { Conversation } from "./types/conversation";

interface ConversationHistoryProps {
  currentThreadId: string | null;
  onSelectConversation: (threadId: string) => void;
  onCreateNewConversation: () => void;
}

const ConversationHistory: React.FC<ConversationHistoryProps> = ({
  currentThreadId,
  onSelectConversation,
  onCreateNewConversation
}) => {
  const isMobile = useIsMobile();
  
  const { 
    conversations, 
    isLoading, 
    error, 
    handleRetryFetch,
    forceRefresh 
  } = useConversations({ currentThreadId });

  const { 
    deleteDialogOpen, 
    conversationToDelete, 
    handleDeleteClick, 
    handleConfirmDelete, 
    closeDeleteDialog 
  } = useConversationDelete({ 
    currentThreadId, 
    onCreateNewConversation,
    forceRefresh 
  });

  const handleSelectConversation = (threadId: string) => {
    console.log("Selecting conversation with thread ID:", threadId);
    onSelectConversation(threadId);
  };

  return (
    <div className="flex flex-col h-full">
      <div className={`${isMobile ? 'p-4' : 'p-3'} border-b`}>
        <h2 className={`font-medium ${isMobile ? 'text-base' : 'text-sm'} text-muted-foreground`}>
          Tidligere samtaler
        </h2>
      </div>
      
      <ConversationList
        conversations={conversations}
        currentThreadId={currentThreadId}
        isLoading={isLoading}
        error={error}
        onSelectConversation={handleSelectConversation}
        onDeleteClick={handleDeleteClick}
        onRetry={handleRetryFetch}
      />

      <ConversationDeleteDialog
        isOpen={deleteDialogOpen}
        onClose={closeDeleteDialog}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
};

export default ConversationHistory;
